import { Settings } from "../../../Settings";
import ValueCalculator from "../../../util/ValueCalculator";
import SkillNodePurchaseListener from "../SkillNodePurchaseListener";
import NumberValueSkillNode from "./NumberValueSkillNode";

export default class DurationSkillNode extends NumberValueSkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {number} valuePerSkillLevel
     * @param {NumberValue} numberValue
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue) {
        super(id, 'Duration + ' + Settings.skill.common.activationSecondsPerUpgrade + ' sec', 
            null, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue);
    }

    /**
     * @returns {string}
     */
    getDescription() {
        return ValueCalculator.getSkillActivationSeconds(this.numberValue) + ' seconds';
    }

}